import React from 'react';
import { Box, Typography } from '@mui/material';
import DashboardLayoutSlots from './DashboardLayoutSlots'; // Import the layout

// Profile component
function PR() {
  return (
    // Make sure DashboardLayoutSlots wraps the Profile page content
    <DashboardLayoutSlots>
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" component="h1">
          Project Request
        </Typography>
        <Typography variant="body1" component="p">
          This is the user's profile page where you can add profile details.
        </Typography>
      </Box>
    </DashboardLayoutSlots>
  );
}


export default PR;

